import { useEffect, useState, useRef } from 'react'
import style from '../index.module.scss'
import { Form, Button, Input, Modal, message } from 'antd'
import * as apis from '../../../api/user'
import { verifyImage, emailCheckCode, phoneCheckCode } from '../../../api/login'
interface Props {
    visible: any
    onClose: () => void;
    onRefresh: () => void;
    type: any;
    title: any;
    info?: any
}

const PopCheck = (props: Props) => {


    const [form] = Form.useForm();
    const [imgUrl, setImgUrl] = useState<string>('');
    const [imgCode, setImgCode] = useState<any>();
    const [textCode, setTextCode] = useState<any>();
    const [disabled, setDisabled] = useState<boolean>(false);
    const timerCount = 60 // 默认60秒
    const [count, setCount] = useState(timerCount)
    const timerRef = useRef<any>(null) // 记录时间的定时器
    const [typeKey, setTypeKey] = useState<any>();
    const [typeName, setTypeName] = useState<any>();
    const [typeDisabled, setTypeDisabled] = useState<boolean>(false);

    const [isCommon, setIsCommon] = useState<boolean>(false);
    const [codeText, setCodeText] = useState<any>('发送验证码');

    const lableList = [
        { name: "邮箱", type: "email", },
        { name: "手机", type: "mobile", },
        { name: "手机", type: "netdisk", },

    ]
    const cutCount = () => {
        setCount((prevState) => prevState - 1) // 为什么这里要用函数- 如果用count 发现count闭包了 不会发生变化了
    }
    const sendCode = () => {
        // 要发送验证码
        setCodeText('重新发送验证码')
        cutCount()
        timerRef.current = setInterval(cutCount, 1000)
    }
    useEffect(() => {

    }, [props.type])
    useEffect(() => {
        if (count === 0) {
            clearInterval(timerRef.current) // 清空定时器
            setCount(timerCount) // 重新将技术器设置为60秒

        }
    }, [count])
    /**
   * @name 重置
   */
    const reset = () => {
        setCount(0)
        form.resetFields();
        setCodeText('发送验证码')
        props.onClose()

    }
    useEffect(() => {
        if (props.visible) {
            onImag()
            let tt = lableList.filter(i => i.type === props.type)
            //common是非指定 邮箱或手机的类型
            if (props.type === 'netdisk') {
                setTypeKey('mobile')
                setIsCommon(true)
            } else {
                setTypeKey(tt[0]?.type)
            }
            console.log(props.info)
            //props.info !=null 说明已经绑定信息，要解绑,并且设置该项输入框为Disabled
            if (props.info != null) {
                form.setFieldsValue({ [props.type]: props.info[props.type] })
                if (props.type === 'netdisk') {
                    setTypeDisabled(false)
                } else {
                    setTypeDisabled(true)
                }

            } else {
                setTypeDisabled(false)
            }

            setTypeName(tt[0]?.name)
        }
    }, [props.visible])
    /**
    * @name 创建图片验证码
    */
    const onImag = async () => {

        try {
            let res: any = await verifyImage(130, 36)
            if (res.ok) {
                setImgUrl(res.data.base64)
                setImgCode(res.data.code)
            }
        } catch (err) { }
    };
    /**
    * @name 绑定/解绑
    */
    const onFinish = async (values: any) => {
        console.log(form.getFieldsValue())
        try {
            let apiUrl: any
            if (isCommon || props.info) {
                apiUrl = apis.delAccount
                // 密码：password
                // 邮件：email
                // 手机：mobile
                // 外部账户：ExternalAccount
                let type: any = null
                let id: any = null
                let params: any = null
                if ((props.type === 'netdisk')) {
                    type = "ExternalAccount"
                    id = props.info.accountId
                    params = {
                        "checkValue": form.getFieldsValue().imgValue,
                        "checkCode": imgCode
                    }
                } else {
                    type = typeKey
                    id = props.info.id
                    params = {
                        "checkValue": form.getFieldsValue().textValue,
                        "checkCode": textCode
                    }
                }
                let res: any = await apiUrl(type, id,
                    params
                )
                if (res.ok) {
                    message.success(`解绑成功`)
                    // form.resetFields();
                    // props.onClose()
                    reset()
                    props.onRefresh()
                }
            } else {
                if (typeKey === 'email') {
                    apiUrl = apis.accountEmail
                } else if (typeKey === 'mobile') {
                    apiUrl = apis.accountMmobile
                }

                let res: any = await apiUrl({
                    [typeKey]: form.getFieldsValue()[typeKey],
                    "value": form.getFieldsValue().textValue,
                    "code": textCode
                })
                if (res.ok) {
                    message.success(`绑定${typeName}成功`)
                    // form.resetFields();
                    // props.onClose()
                    reset()
                    props.onRefresh()

                }
            }
        } catch (err) {
            onImag()
            // form.resetFields();
            form.resetFields(['imgValue', 'textValue'])
            setCount(0)
        }
    };
    /**
       * @name 校验失败
       */
    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };
    /**
       * @name 获取验证码
       */
    const sendCodeFuc = async () => {
        sendCode()

        try {

            const { imgValue } = form.getFieldsValue()
            let apiType: any
            let apiUrl: any
            if (typeKey === 'email') {
                apiType = 'verify_email'
                apiUrl = emailCheckCode
            } else if (typeKey === 'mobile') {
                apiType = 'zwf_verify'
                apiUrl = phoneCheckCode
            }
            let res: any = await apiUrl(form.getFieldsValue()[typeKey], apiType, imgCode, imgValue);
            setTextCode(res.data)

        } catch (err) {
            onImag()
            form.resetFields(['imgValue'])
            setCount(0)
        }

    }
    const phoneCheck = (e: any) => {

    }
    return (
        <Modal
            centered
            footer={null}
            onCancel={() => {
                reset()
            }}
            width={'500px'}
            title={props.title}
            open={props.visible}>
            <div>
                <Form
                    name="basic"
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 16 }}
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                    form={form}
                    onValuesChange={(e) => {
                        console.log(e)
                        if (form.getFieldValue(typeKey) && form.getFieldValue('imgValue')) {
                            setDisabled(false)
                        } else {
                            setDisabled(true)
                        }
                    }}

                >
                    {/* 网盘只需要验证图片 */}
                    {props.type === 'netdisk' ? <></> :
                        <Form.Item
                            label={typeName}
                            name={typeKey}

                            // help={validateHelp}
                            rules={(typeKey === 'mobile') ?
                                [{ required: true, message: `请输入${typeName}`, },
                                {
                                    validator: async (_, value) => {
                                        let phoneReg = /^[1][3,4,5,7,8][0-9]{9}$/;
                                        let flag: any
                                        if (!phoneReg.test(value)) {
                                            return Promise.reject('请输入正确手机号')

                                        } else {
                                            return Promise.resolve()

                                        }

                                    },
                                }] :
                                [{ required: true, message: `请输入${typeName}` }]}
                        >
                            {/* <Input className={style.input} /> */}
                            <Input className={style.input} disabled={typeDisabled}
                                suffix={
                                    isCommon ?
                                        <div className='cursor' onClick={(e) => {
                                            setTypeKey(typeKey === 'mobile' ? 'email' : 'mobile')
                                            setTypeName(typeKey === 'mobile' ? '邮箱' : '手机')

                                        }}>{typeKey === 'mobile' ? "切换邮箱" : `切换手机`}</div> : ""} />
                        </Form.Item>
                    }
                    <Form.Item
                        label="图片验证码"
                        name="imgValue"
                        rules={[{ required: true, message: '请输入图片验证码' }]}
                    >
                        <div data-flex="main:left">

                            <img alt="" style={{ width: "130px", height: "36px", marginRight: "10px" }} onClick={() => { onImag() }} src={imgUrl} /> <Input className={style.input} /></div>

                    </Form.Item>
                    {/* 网盘只需要验证图片 */}
                    {props.type === 'netdisk' ? <></> :
                        <Form.Item
                            label="验证码"
                            name="textValue"
                            rules={[
                                { required: true, message: '请输入验证码' },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!getFieldValue(typeKey) && !getFieldValue('imgValue') && value) {
                                            return Promise.reject(new Error(`请先输入${typeName}和图片验证码`));
                                        } else {
                                            return Promise.resolve();

                                        }

                                    },
                                })
                            ]}
                        >
                            <Input disabled={disabled} className={style.input}
                                suffix={<div className='cursor' onClick={(e) => {
                                    if (!form.getFieldValue(typeKey) || !form.getFieldValue('imgValue')) {
                                        form.validateFields([typeKey])
                                        form.validateFields(['imgValue'])
                                        return
                                    } else {
                                        sendCodeFuc()
                                    }
                                }}>{count === timerCount ? `${codeText}` : `${count}秒`}</div>} />
                        </Form.Item>
                    }
                    <Form.Item wrapperCol={{ offset: 6, span: 16 }}>
                        <div data-flex='main:left' >
                            {/* <Button className='btn_default mr-10 btn' onClick={() => { setPassVisible(false); form.resetFields(); }} >取消</Button> */}
                            <Button className='btn_default mr-10 btn' onClick={() => { reset() }} >取消</Button>
                            <Button className='btn_dark btn' htmlType="submit">确认</Button>
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    )
}

export default PopCheck